import {Box,TextField,InputAdornment,IconButton} from '@mui/material';
import {ArrowCircleRight} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import {DefaultConfig} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldTextDrilldown=({row,fieldName,application})=>{
    const navigate=useNavigate();
    const fieldProp=row?.[fieldName];
    const fieldValue=fieldProp?.row.name;

    // `same_tab` is an opt-in per-field flag (see backend virtual field defs,
    // e.g. AnalysisRequest.analysis_report) - defaults to the original
    // new-tab behavior so existing drilldowns (e.g. AnalysisRequest.account)
    // are unaffected.
    const handleClickDrilldown=()=>{
        const url=fieldProp?.drilldown_link.replace("{ENTITY_ID}", fieldProp?.row.id);
        if(fieldProp?.same_tab){
            navigate(url);
        }
        else{
            window.open(url,'_blank','noopener,noreferrer');
        }
    }
    return (
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                style={{marginTop:"0px",marginBottom:"8px"}}
                sx={{div:{backgroundColor:readOnlyBackgroundColor}}}
                InputProps={{
                    readOnly:true,                                    
                    endAdornment:(
                        fieldProp?.row.id!==''&&
                        <InputAdornment position="end">
                            <IconButton onClick={(e)=>handleClickDrilldown()} color="primary">
                                <ArrowCircleRight/>
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                id={fieldName}
                name={fieldName}
                fullWidth
                variant="outlined"
                size="small"
                label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                value={fieldValue}
                margin="normal"/>
        </Box>
    );
}

export default FieldTextDrilldown;
